export default [
  // {
  //   path: '/apps/calendar',
  //   name: 'apps-calendar',
  //   component: () => import('@/views/apps/calendar/Calendar.vue'),
  // },
  {
    path: "/questions/create",
    name: "apps-questions",
    component: () => import("@/views/apps/questions/CreateQuestion.vue"),
    meta: {
      resource: "Question",
      action: "Create",
    },
  },
  {
    path: "/questions",
    name: "apps-questions-list",
    component: () => import("@/views/apps/questions/QuestionsList.vue"),
    meta: {
      resource: "Question",
      action: "GetAll",
    },
  },
  {
    path: "/questions/:id",
    name: "apps-question-single",
    component: () => import("@/views/apps/questions/QuestionEdit.vue"),
    meta: {
      resource: "Question",
      action: "Update",
    },
  },
  {
    path: "/languages/create",
    name: "apps-languages",
    component: () => import("@/views/apps/languages/CreateLanguage.vue"),
    meta: {
      resource: "Language",
      action: "Create",
    },
  },
  {
    path: "/languages/:id",
    name: "apps-languages-update",
    component: () => import("@/views/apps/languages/UpdateLanguage.vue"),
    meta: {
      resource: "Language",
      action: "Update",
    },
  },
  {
    path: "/languages/:id/lessons",
    name: "apps-languages-lessons",
    component: () => import("@/views/apps/languages/AddLessonsToLanguage.vue"),
    meta: {
      resource: "IndependentLesson",
      action: "Create",
    },
  },
  {
    path: "/languages/",
    name: "apps-languages-list",
    component: () => import("@/views/apps/languages/LanguagesList.vue"),
    meta: {
      resource: "Language",
      action: "GetAll",
    },
  },
  {
    path: "/courses/course-type/create",
    name: "apps-courses-course-type-create",
    component: () =>
      import("@/views/apps/courses/CourseType/CreateCourseType.vue"),
    meta: {
      resource: "CourseType",
      action: "Create",
    },
  },
  {
    path: "/courses/course-type/",
    name: "apps-courses-course-type",
    component: () =>
      import("@/views/apps/courses/CourseType/GetAllCourseTypes.vue"),
    meta: {
      resource: "CourseType",
      action: "GetAll",
    },
  },
  {
    path: "/courses/create/",
    name: "apps-course-create",
    component: () => import("@/views/apps/courses/CreateCourse.vue"),
    meta: {
      resource: "Course",
      action: "Create",
    },
  },
  {
    path: "/courses/",
    name: "apps-course-list",
    component: () => import("@/views/apps/courses/GetAllCourses.vue"),
    meta: {
      resource: "Course",
      action: "GetAll",
    },
  },
  {
    path: "/courses/assign-master",
    name: "apps-course-master-active",
    component: () =>
      import("@/views/apps/MasterActiveCourse/CreateMasterActiveCourse.vue"),
    meta: {
      resource: "MasterActiveCourse",
      action: "Create",
    },
  },
  {
    path: "/courses/:id",
    name: "apps-course-edit",
    component: () => import("@/views/apps/courses/EditACourse.vue"),
    meta: {
      resource: "Course",
      action: "Update",
    },
  },
  {
    path: "/roles/",
    name: "apps-role-access",
    component: () => import("@/views/apps/access/RolesList.vue"),
    meta: {
      resource: "UserType",
      action: "GetAll",
    },
  },
  {
    path: "/roles/:id",
    name: "apps-role-access-manage",
    component: () => import("@/views/apps/access/RoleManagement.vue"),
    meta: {
      resource: "UserType",
      action: "GetRoleAccess",
    },
  },
  {
    path: "/access/logs",
    name: "apps-role-access-log",
    component: () => import("@/views/apps/access/AccessCtrlActionLog.vue"),
    meta: {
      resource: "AccessCtrlActionRequire",
      action: "GetList",
    },
  },
  {
    path: "/roadmap/create",
    name: "apps-roadmap-create",
    component: () => import("@/views/apps/roadmap/CreateRoadmap.vue"),
  },
  {
    path: "/roadmap/defaults",
    name: "apps-roadmap-default",
    component: () => import("@/views/apps/roadmap/UpdateDefaultRoadmap.vue"),
  },
  {
    path: "/students/pending-to-specify-level",
    name: "apps-students-pending",
    component: () => import("@/views/apps/students/WaitingForRoadmap.vue"),
    meta: {
      resource: "RoadMap",
      action: "SpecifyStudentLevel",
    },
  },
  {
    path: "/students/pending-to-specify-level/:id",
    name: "apps-students-pending-single",
    component: () => import("@/views/apps/students/SingleStudentRoadmap.vue"),
    meta: {
      resource: "RoadMap",
      action: "SpecifyStudentLevel",
    },
  },
  {
    path: "/students/roadmaps/list",
    name: "apps-students-roadmapsList",
    component: () => import("@/views/apps/students/RoadmapsList.vue"),
    meta: {
      resource: "RoadMapGroupSimple",
      action: "GetList",
    },
  },
  {
    path: "/students/roadmaps/:id",
    name: "apps-students-roadmap-edit",
    component: () => import("@/views/apps/students/EditASingleRoadmap.vue"),
    meta: {
      resource: "RoadMapGroupSimple",
      action: "GetById",
    },
  },
  {
    path: "/students/roadmaps/create/:langId/:userId",
    name: "apps-students-roadmap-edit-create",
    component: () => import("@/views/apps/students/EditASingleRoadmap.vue"),
    meta: {
      resource: "RoadMapGroupSimple",
      action: "CreateUpdate",
    },
  },
  {
    path: "/lessons/:id",
    name: "apps-lessons-edit",
    component: () => import("@/views/apps/lessons/EditALesson.vue"),
    meta: {
      resource: "Lesson",
      action: "Update",
    },
  },
  {
    path: "/independent-lessons/:id",
    name: "apps-independent-lessons-edit",
    component: () => import("@/views/apps/lessons/EditAnIndependentLesson.vue"),
    meta: {
      resource: "IndependentLesson",
      action: "Update",
    },
  },
  {
    path: "/courses/course-type/:id",
    name: "apps-course-type-edit",
    component: () =>
      import("@/views/apps/courses/CourseType/EditCourseType.vue"),
    meta: {
      resource: "CourseType",
      action: "Update",
    },
  },
  {
    path: "/master/schedule",
    name: "apps-master-schedule",
    component: () =>
      import("@/views/apps/MasterSchedule/MasterScheduleByPeriod.vue"),
    meta: {
      resource: "MasterSchedule",
      action: "GetAllV2ForMaster",
    },
  },
  {
    path: "/master/users",
    name: "apps-master-users",
    component: () => import("@/views/apps/Users/MasterUsersList.vue"),
    meta: {
      resource: "Users",
      action: "GetMyStudentList",
    },
  },
  {
    path: "/master/absence-reports/list",
    name: "apps-master-absence-reports-list",
    component: () =>
      import("@/views/apps/Schedule/MasterAbsenceReportList.vue"),
    meta: {
      resource: "Schedule",
      action: "GetStudentReports",
    },
  },
  {
    path: "/master/block-list",
    name: "apps-master-block-list",
    component: () => import("@/views/apps/Block/MastersBlockList.vue"),
    meta: {
      resource: "Users",
      action: "GetMasterBlockList",
    },
  },
  {
    path: "/absence-masters/list",
    name: "absence-masters-list",
    component: () =>
      import("@/views/apps/Schedule/MasterAbsenceReportListForAdmin.vue"),
    meta: {
      resource: "Schedule",
      action: "GetAllSchedulePayBack",
    },
  },
  {
    path: "/master/users/:id/:priceCategoryId?",
    name: "apps-master-users-details",
    component: () => import("@/views/apps/Users/MasterUserRoadmapDetails.vue"),
    meta: {
      resource: "Users",
      action: "GetMyStudentList",
    },
  },
  {
    path: "/users",
    name: "apps-users-all",
    component: () => import("@/views/apps/Users/GetAllUsersList.vue"),
    props: {
      isVipUsersList: false,
    },
    meta: {
      resource: "Users",
      action: "GetAll",
    },
  },
  {
    path: "/lessonsAnalytics",
    name: "lessons-analytics",
    component: () => import("@/views/apps/lessons/LessonsAnalytics.vue"),
    props: {
      isVipUsersList: false,
    },
    meta: {
      resource: "Lesson",
      action: "GetOrderLessons",
    },
  },

  {
    path: "/users/leads",
    name: "apps-users-leads",
    component: () => import("@/views/apps/Users/UsersLeadsList.vue"),
    meta: {
      resource: "Users",
      action: "GetAll", // FIXME
    },
  },

  {
    path: "/apps/users/shared",
    name: "apps-users-shared-accounts",
    component: () => import("@/views/apps/Shared/UsersFamilyList.vue"),
    meta: {
      resource: "Users",
      action: "GetUserFamiliesForAdmin",
    },
  },
  {
    path: "/users/create",
    name: "apps-users-create",
    component: () => import("@/views/apps/Users/CreateANewUser.vue"),
    meta: {
      resource: "Users",
      action: "Create",
    },
  },
  {
    path: "/users/masters",
    name: "apps-masters-all",
    component: () => import("@/views/apps/masters/GetAllMastersList.vue"),
    meta: {
      resource: "Users",
      action: "GetAll",
    },
  },
  {
    path: "/users/masters-salary",
    name: "apps-masters-salary-all",
    component: () =>
      import("@/views/apps/Users/MastersSalaryMainReportList.vue"),
    meta: {
      resource: "MasterUserPayment",
      action: "GetList",
    },
  },
  {
    path: "/users/masters-salary/income-outcome",
    name: "apps-masters-income-outcome",
    component: () => import("@/views/apps/Users/MastersIncomeOutcomeList.vue"),
    meta: {
      resource: "IncomeOutcomeTransaction",
      action: "GetMasterIncomeOutcomeList",
    },
  },
  {
    path: "/master/reserved-consultations",
    name: "apps-masters-homework",
    component: () =>
      import("@/views/apps/HomeWorks/MasterReservedHomeworks.vue"),
    meta: {
      resource: "HomeWorks",
      action: "GetAllHomeWorkPerDate",
    },
  },
  {
    path: "/master/my-salary",
    name: "apps-master-single-salary",
    component: () => import("@/views/apps/MasterSchedule/MasterSalary.vue"),
    meta: {
      resource: "MasterUserPayment",
      action: "GetListForMaster",
    },
  },
  {
    path: "/master/my-salary/:id",
    name: "apps-master-single-salary-details",
    component: () =>
      import("@/views/apps/MasterSchedule/MasterSingleSalaryDetails.vue"),
    meta: {
      resource: "MasterUserPayment",
      action: "GetListForMaster",
    },
  },
  {
    path: "/users/masters-salary/:id",
    name: "apps-masters-salary-single",
    component: () => import("@/views/apps/Users/MasterSalaryList.vue"),
    meta: {
      resource: "MasterUserPayment",
      action: "GetById",
    },
  },
  {
    path: "/users/masters-salary/:id/:masterUserId",
    name: "apps-masters-salary-single-with-master-id",
    component: () => import("@/views/apps/Users/MasterSalarySingle.vue"),
    meta: {
      resource: "MasterUserPayment",
      action: "GetById",
    },
  },
  {
    path: "/users/:id",
    name: "apps-users-single",
    component: () => import("@/views/apps/Users/UpdateASingleUser.vue"),
    meta: {
      resource: "Users",
      action: "GetByAdmin",
    },
  },
  {
    path: "/blogs/categories",
    name: "apps-blog-categories",
    component: () =>
      import("@/views/apps/blog/BlogCategory/GetAllBlogCategories.vue"),
    meta: {
      resource: "BlogCategory",
      action: "GetAll",
    },
  },
  {
    path: "/blogs",
    name: "apps-blog-list",
    component: () => import("@/views/apps/blog/GetAllBlogs.vue"),
    meta: {
      resource: "Blog",
      action: "GetAllByAdmin",
    },
  },
  {
    path: "/blogs/create",
    name: "apps-blog-create",
    component: () => import("@/views/apps/blog/CreateABlog.vue"),
    meta: {
      resource: "Blog",
      action: "Create",
    },
  },
  {
    path: "/blogs/:id",
    name: "apps-blog-update",
    component: () => import("@/views/apps/blog/UpdateABlog.vue"),
    meta: {
      resource: "Blog",
      action: "Update",
    },
  },
  {
    path: "/orders",
    name: "apps-orders-list",
    component: () => import("@/views/apps/orders/GetAllOrders.vue"),
    meta: {
      resource: "Order",
      action: "GetAll",
    },
  },
  {
    path: "/orders/:id",
    name: "apps-orders-single",
    component: () => import("@/views/apps/orders/GetASingleOrder.vue"),
    meta: {
      resource: "Order",
      action: "Get",
    },
  },
  {
    path: "/offers/daily-discounts-analytics",
    name: "apps-daily-discounts-analytics",
    component: () =>
      import("@/views/apps/DailyDiscountAnalytics/DailyDiscountList.vue"),
    meta: {
      resource: "Schedule",
      action: "GetAllUserSchedule",
    },
  },
  {
    path: "/offers/course/",
    name: "apps-discounts-course-create",
    component: () =>
      import("@/views/apps/offers/course/CreateDiscountForCourse.vue"),
    meta: {
      resource: "Discount",
      action: "Create",
    },
  },
  {
    path: "/offers/lesson/",
    name: "apps-discounts-lesson-create",
    component: () =>
      import("@/views/apps/offers/lesson/CreateDiscountForLesson.vue"),
    meta: {
      resource: "Discount",
      action: "Create",
    },
  },
  {
    path: "/master/reserved",
    name: "apps-master-reserved",
    component: () => import("@/views/apps/MasterSchedule/ActiveSchedules.vue"),
    meta: {
      resource: "Schedule",
      action: "GetAll",
    },
  },
  {
    path: "/master/profile",
    name: "apps-masters-profile",
    component: () =>
      import("@/views/apps/MasterSchedule/UpdateMasterProfile.vue"),
    meta: {
      resource: "Users",
      action: "Update",
    },
  },
  {
    path: "/master/reserved/:id",
    name: "apps-master-single-reserved",
    component: () => import("@/views/apps/MasterSchedule/SingleSchedule.vue"),
    meta: {
      resource: "Schedule",
      action: "GetBy",
    },
  },
  {
    path: "/master/reserved/:id/exam-create",
    name: "apps-master-single-reserved-exam",
    component: () =>
      import("@/views/apps/MasterSchedule/CreateExamForSchedule.vue"),
    meta: {
      resource: "Schedule",
      action: "Update",
    },
  },
  {
    path: "/master/reserved/:id/report",
    name: "apps-master-single-reserved-report",
    component: () => import("@/views/apps/MasterSchedule/StudentReport.vue"),
    meta: {
      resource: "Schedule",
      action: "GetBy",
    },
  },
  // TODO: WTF is this?
  {
    path: "/master/reserved/:id/report/:examId",
    name: "apps-master-single-reserved-exam-report",
    component: () => import("@/views/apps/MasterSchedule/SingleExamReport.vue"),
    meta: {
      resource: "sessions",
      action: "sessions",
    },
  },
  {
    path: "/master/exams",
    name: "apps-master-exams",
    component: () => import("@/views/apps/MasterSchedule/MasterAllExams.vue"),
    meta: {
      resource: "Exam",
      action: "GetAll",
    },
  },
  {
    path: "/master/exams/:id",
    name: "apps-master-exams-id",
    component: () =>
      import("@/views/apps/MasterSchedule/MasterSingleExamResult.vue"),
    meta: {
      resource: "Exam",
      action: "GetBy",
    },
  },
  {
    path: "/apps/allTickets",
    name: "apps-allTickets",
    component: () => import("@/views/apps/Ticket/AllTickets.vue"),
    meta: {
      resource: "Ticket",
      action: "GetAll",
    },
  },
  {
    path: "/apps/ticketDetail/:id",
    name: "apps-ticketDetail-id",
    component: () => import("@/views/apps/Ticket/Detail/TicketDetail.vue"),
    meta: {
      resource: "Ticket",
      action: "GetAllByParentId",
    },
  },
  {
    path: "/apps/comments/list",
    name: "apps-comments-list",
    component: () => import("@/views/apps/comments/GetAllComments.vue"),
    meta: {
      resource: "Comment",
      action: "GetAll",
    },
  },
  {
    path: "/apps/dynamic-pages",
    name: "apps-dynamic-pages",
    component: () => import("@/views/apps/dynamicPages/GetAllDynamics.vue"),
    meta: {
      resource: "DynamicPage",
      action: "GetAll",
    },
  },
  {
    path: "/apps/dynamic-pages/faq/:id",
    name: "apps-dynamic-faq",
    component: () => import("@/views/apps/dynamicPages/FaqPage.vue"),
    meta: {
      resource: "DynamicPage",
      action: "GetBy",
    },
  },
  {
    path: "/apps/dynamic-pages/footer/:id",
    name: "apps-dynamic-footer",
    component: () => import("@/views/apps/dynamicPages/FooterPage.vue"),
    meta: {
      resource: "DynamicPage",
      action: "GetBy",
    },
  },
  {
    path: "/apps/dynamic-pages/latest-news/:id",
    name: "apps-dynamic-news",
    component: () => import("@/views/apps/dynamicPages/LatestNews.vue"),
    meta: {
      resource: "DynamicPage",
      action: "GetBy",
    },
  },
  {
    path: "/apps/dynamic-pages/about-us/:id",
    name: "apps-dynamic-about-us",
    component: () => import("@/views/apps/dynamicPages/AboutPage.vue"),
    meta: {
      resource: "DynamicPage",
      action: "GetBy",
    },
  },
  {
    path: "/apps/exams/public/create",
    name: "apps-exams-public-create",
    component: () =>
      import("@/views/apps/exams/publicExams/CreateNewPublicExam.vue"),
    meta: {
      resource: "PublicExam",
      action: "Create",
    },
  },
  {
    path: "/apps/exams/public",
    name: "apps-exams-public-list",
    component: () =>
      import("@/views/apps/exams/publicExams/PublicExamsList.vue"),
    meta: {
      resource: "PublicExam",
      action: "GetAll",
    },
  },
  {
    path: "/apps/exams/public/:id",
    name: "apps-exams-public-update",
    component: () =>
      import("@/views/apps/exams/publicExams/UpdateAPublicExam.vue"),
    meta: {
      resource: "PublicExam",
      action: "Update",
    },
  },
  {
    path: "/reports",
    name: "apps-reports-all",
    component: () => import("@/views/apps/reports/ReportsList.vue"),
    meta: {
      resource: "Report",
      action: "GetAll",
    },
  },
  {
    path: "/apps/tiered-discount/create",
    name: "apps-step-discount-create",
    component: () =>
      import(
        "@/views/apps/ScheduleStepDiscount/CreateScheduleStepDiscount.vue"
      ),
    meta: {
      resource: "ScheduleStepDiscount",
      action: "Create",
    },
  },
  {
    path: "/apps/tiered-discount/list",
    name: "apps-step-discount-list",
    component: () =>
      import("@/views/apps/ScheduleStepDiscount/ScheduleStepDiscountList.vue"),
    meta: {
      resource: "ScheduleStepDiscount",
      action: "GetList",
    },
  },
  {
    path: "/apps/tiered-discount/:id",
    name: "apps-step-discount-update",
    component: () =>
      import(
        "@/views/apps/ScheduleStepDiscount/UpdateScheduleStepDiscount.vue"
      ),
    meta: {
      resource: "ScheduleStepDiscount",
      action: "Update",
    },
  },
  {
    path: "/apps/loyalty-discount/create",
    name: "apps-loyalty-discount-create",
    component: () =>
      import(
        "@/views/apps/ScheduleLoyaltyDiscount/CreateScheduleLoyaltyDiscount"
      ),
    meta: {
      resource: "ScheduleLoyaltyDiscount",
      action: "Create",
    },
  },
  {
    path: "/apps/loyalty-level/create",
    name: "apps-loyalty-level-create",
    component: () =>
        import(
            "@/views/apps/ScheduleLoyaltyDiscount/CreateLevels.vue"
            ),
    meta: {
      resource: "ScheduleLoyaltyDiscount",
      action: "Create",
    },
  },
  {
    path: "/apps/loyalty-level/getList",
    name: "apps-loyalty-level-getList",
    component: () =>
        import(
            "@/views/apps/ScheduleLoyaltyDiscount/LoyadltyUsers/index.vue"
            ),
    meta: {
      resource: "ScheduleLoyaltyDiscount",
      action: "GetList",
    },
  },
  {
    path: "/apps/loyalty-level/getList/:id",
    name: "apps-loyalty-level-getList-levelLoyaltyId",
    component: () =>
        import(
            "@/views/apps/ScheduleLoyaltyDiscount/LoyadltyUsers/[levelLoyaltUserId].vue"
            ),
    meta: {
      resource: "ScheduleLoyaltyDiscount",
      action: "GetList",
    },
  },
  {
    path: "/apps/loyalty-discount/list",
    name: "apps-loyalty-discount-list",
    component: () =>
      import(
        "@/views/apps/ScheduleLoyaltyDiscount/ScheduleLoyaltyDiscountList.vue"
      ),
    meta: {
      resource: "ScheduleLoyaltyDiscount",
      action: "GetList",
    },
  },
  {
    path: "/apps/loyalty-discount/:id",
    name: "apps-loyalty-discount-update",
    component: () =>
      import(
        "@/views/apps/ScheduleLoyaltyDiscount/UpdateScheduleLoyaltyDiscount.vue"
      ),
    meta: {
      resource: "ScheduleLoyaltyDiscount",
      action: "Update",
    },
  },
  {
    path: "/apps/loyalty-discount-badge/list",
    name: "apps-loyalty-discount-badge-list",
    component: () =>
      import("@/views/apps/ScheduleLoyaltyDiscount/Badges/BadgeList.vue"),
    meta: {
      resource: "ScheduleLoyaltyDiscount",
      action: "GetList",
    },
  },
  {
    path: "/apps/masters-levels/create",
    name: "apps-masters-levels-create",
    component: () =>
      import("@/views/apps/MastersLevels/CreateNewMasterLevel.vue"),
    meta: {
      resource: "ScheduleMasterRegular",
      action: "Create",
    },
  },
  {
    path: "/apps/masters-levels/list",
    name: "apps-masters-levels-list",
    component: () => import("@/views/apps/MastersLevels/MasterLevelsList.vue"),
    meta: {
      resource: "ScheduleMasterRegular",
      action: "GetList",
    },
  },
  {
    path: "/apps/language-managers/list",
    name: "apps-language-managers-list",
    component: () =>
      import("@/views/apps/LanguageManagers/LanguageManagersList.vue"),
    meta: {
      resource: "LanguageManagers",
      action: "GetAll",
    },
  },
  {
    path: "/apps/language-managers/create",
    name: "apps-language-managers-create",
    component: () =>
      import("@/views/apps/LanguageManagers/CreateANewLanguageManager.vue"),
    meta: {
      resource: "LanguageManagers",
      action: "Create",
    },
  },
  {
    path: "/apps/language-managers/:id",
    name: "apps-language-managers-update",
    component: () =>
      import("@/views/apps/LanguageManagers/UpdateALanguageManager.vue"),
    meta: {
      resource: "LanguageManagers",
      action: "Update",
    },
  },
  {
    path: "/apps/literacy-badges/list",
    name: "apps-literacy-badges-list",
    component: () =>
      import("@/views/apps/LiteracyBadges/LiteracyBadgeList.vue"),
    meta: {
      resource: "LiteracyBadges",
      action: "GetAll",
    },
  },
  {
    path: "/apps/literacy-badges/create",
    name: "apps-literacy-badges-create",
    component: () =>
      import("@/views/apps/LiteracyBadges/CreateALiteracyBadge.vue"),
    meta: {
      resource: "LiteracyBadges",
      action: "GetAll",
    },
  },
  {
    path: "/apps/literacy-badges/:id",
    name: "apps-literacy-badges-update",
    component: () =>
      import("@/views/apps/LiteracyBadges/UpdateALiteracyBadge.vue"),
    meta: {
      resource: "LiteracyBadges",
      action: "Get",
    },
  },
  {
    path: "/apps/masters-levels/:id",
    name: "apps-masters-levels-update",
    component: () => import("@/views/apps/MastersLevels/UpdateMasterLevel.vue"),
    meta: {
      resource: "ScheduleMasterRegular",
      action: "Create",
    },
  },
  {
    path: "/apps/groups/new",
    name: "apps-category-price-create",
    component: () =>
      import("@/views/apps/PriceCategory/CreateNewPriceCategory.vue"),
    meta: {
      resource: "PriceCategory",
      action: "Create",
    },
  },
  {
    path: "/apps/groups/list",
    name: "apps-category-price-list",
    component: () => import("@/views/apps/PriceCategory/PriceCategoryList.vue"),
    meta: {
      resource: "ScheduleMasterRegular",
      action: "GetList",
    },
  },
  {
    path: "/apps/groups/:id",
    name: "apps-category-price-update",
    component: () =>
      import("@/views/apps/PriceCategory/UpdateAPriceCategory.vue"),
    meta: {
      resource: "ScheduleMasterRegular",
      action: "Update",
    },
  },
  // Vip Plans
  {
    path: "/apps/vip/plans/create",
    name: "apps-vip-plans-create",
    component: () => import("@/views/apps/VipPlans/CreateNewVipPlan.vue"),
    meta: {
      resource: "VipUser",
      action: "Create",
    },
  },
  {
    path: "/apps/vip/plans",
    name: "apps-vip-plans",
    component: () => import("@/views/apps/VipPlans/VipPlansList.vue"),
    meta: {
      resource: "VipUser",
      action: "GetList",
    },
  },

  {
    path: "/apps/vip/users",
    name: "apps-vip-plans-users",
    component: () => import("@/views/apps/Users/GetAllUsersList.vue"),
    props: {
      isVipUsersList: true,
    },
    meta: {
      resource: "Users",
      action: "GetAll",
    },
  },
  {
    path: "/apps/vip/plans/:id",
    name: "apps-vip-plans-update",
    component: () => import("@/views/apps/VipPlans/EditVipPlan.vue"),
    meta: {
      resource: "VipUser",
      action: "Update",
    },
  },
  {
    path: "/apps/surveys/create",
    name: "apps-surveys-create",
    component: () => import("@/views/apps/surveys/CreateASurvey.vue"),
    meta: {
      resource: "SurveyUserSurvey",
      action: "CreateSurvey",
    },
  },
  {
    path: "/apps/surveys/list",
    name: "apps-surveys-list",
    component: () => import("@/views/apps/surveys/SurveyList.vue"),
    meta: {
      resource: "SurveyUserSurvey",
      action: "CreateSurvey",
    },
  },
  {
    path: "/apps/surveys/reports",
    name: "apps-surveys-report",
    component: () => import("@/views/apps/surveys/SurveyReports.vue"),
    meta: {
      resource: "SurveyUserSurvey",
      action: "CreateSurvey",
    },
  },
  {
    path: "/apps/surveys/reports/:masterId/:surveyId",
    name: "apps-surveys-report-single",
    component: () =>
      import("@/views/apps/surveys/SurveyReportOfSingleMaster.vue"),
    meta: {
      resource: "SurveyUserSurvey",
      action: "CreateSurvey",
    },
  },
  {
    path: "/apps/surveys/:id",
    name: "apps-surveys-edit",
    component: () => import("@/views/apps/surveys/EditASingleSurvey.vue"),
    meta: {
      resource: "SurveyUserSurvey",
      action: "CreateSurvey",
    },
  },
  {
    path: "/apps/schedules/list",
    name: "reserved-schedules-list",
    component: () => import("@/views/apps/Schedule/GetScheduleList.vue"),
    meta: {
      resource: "Schedule",
      action: "GetList",
    },
  },
  {
    path: "/apps/settings",
    name: "site-settings",
    component: () => import("@/views/apps/SiteSetting/GeneralSiteSetting.vue"),
    meta: {
      resource: "ScheduleMasterRegular",
      action: "Create",
    },
  },
  {
    path: "/apps/lesson-categories/list",
    name: "apps-lessons-package",
    component: () =>
      import("@/views/apps/LessonCategories/LessonCategoriesList.vue"),
    meta: {
      resource: "LessonCategory",
      action: "GetList",
    },
  },
  {
    path: "/apps/lesson-categories/orders",
    name: "apps-lessons-package-orders",
    component: () =>
      import("@/views/apps/LessonCategories/LessonCategoryOrders.vue"),
    meta: {
      resource: "Order",
      action: "GetOrderDetail",
    },
  },
  {
    path: "/apps/notifications/send",
    name: "apps-notifications-send",
    component: () => import("@/views/apps/Notifications/SendNotification.vue"),
    meta: {
      resource: "Notifications",
      action: "SendNotification",
    },
  },
  {
    path: "/apps/resources/list",
    name: "apps-resources-list",
    component: () => import("@/views/apps/Resources/ResourceList.vue"),
    meta: {
      resource: "Resources",
      action: "GetAllResource",
    },
  },
  {
    path: "/apps/resources/create",
    name: "apps-resources-create",
    component: () =>
      import("@/views/apps/Resources/CreateResourceForLanguage.vue"),
    meta: {
      resource: "Resources",
      action: "AddResourceDetailToResourceByLanguageId",
    },
  },
  {
    path: "/apps/resources/:id",
    name: "apps-resources-details",
    component: () =>
      import("@/views/apps/Resources/ResourceDetails/ResourceDetailsList.vue"),
    meta: {
      resource: "Resources",
      action: "GetResourceDetailsById",
    },
  },
  {
    path: "/apps/observer/list",
    name: "apps-observer-list",
    component: () => import("@/views/apps/Observe/TodayObserveList.vue"),
    meta: {
      resource: "Master",
      action: "ObserveTodayMasters",
    },
  },
  {
    path: "/apps/matches/settings/list",
    name: "apps-matches-settings-list",
    component: () => import("@/views/apps/Matches/MatchSettingsList.vue"),
    meta: {
      resource: "Matches",
      action: "GetAllMatchSettings",
    },
  },
  {
    path: "/apps/matches/list",
    name: "apps-matches-list",
    component: () => import("@/views/apps/Matches/MatchList.vue"),
    meta: {
      resource: "Matches",
      action: "GetAllMatches",
    },
  },
  {
    path: "/apps/matches/:id",
    name: "apps-match-detail",
    component: () => import("@/views/apps/Matches/MatchDetails.vue"),
    meta: {
      resource: "Matches",
      action: "GetMatchBy",
    },
  },
  {
    path: "/apps/matches/question-packs/list",
    name: "apps-matches-questions-pack-list",
    component: () =>
      import("@/views/apps/MatchQuestionPackage/MatchQuestionPackageList.vue"),
    meta: {
      resource: "Matches",
      action: "GetAllMatchQuestionPackage",
    },
  },
  {
    path: "/apps/referral-discounts/list",
    name: "apps-master-discount-codes-list",
    component: () =>
      import("@/views/apps/MasterDiscountCode/MasterDiscountCodeList.vue"),
    meta: {
      resource: "MasterDiscountCodes",
      action: "GetAll",
    },
  },
  {
    path: "/apps/referral-discounts/create",
    name: "apps-master-discount-codes-create",
    component: () =>
      import("@/views/apps/MasterDiscountCode/CreateMasterDiscountCode.vue"),
    meta: {
      resource: "MasterDiscountCodes",
      action: "CreateMasterDiscountCode",
    },
  },
  {
    path: "/apps/referral-discounts/:id",
    name: "apps-master-discount-codes-update",
    component: () =>
      import("@/views/apps/MasterDiscountCode/UpdateMasterDiscountCode.vue"),
    meta: {
      resource: "MasterDiscountCodes",
      action: "UpdateMasterDiscountCode",
    },
  },
  {
    path: "/apps/bulk-discounts/list",
    name: "apps-bulk-discounts-list",
    component: () =>
      import("@/views/apps/VolumeDiscounts/VolumeDiscountsList.vue"),
    meta: {
      resource: "VolumeDiscounts",
      action: "GetAll",
    },
  },
  {
    path: "/apps/group-class/list",
    name: "apps-group-class-list",
    component: () => import("@/views/apps/GroupClass/GroupClassList.vue"),
    meta: {
      resource: "GroupClass",
      action: "GetAllGroupClass",
    },
  },
  {
    path: "/apps/group-class/:id",
    name: "apps-group-class-update",
    component: () => import("@/views/apps/GroupClass/SingleGroupClass.vue"),
    meta: {
      resource: "GroupClass",
      action: "UpdateGroupClassByAdmin",
    },
  },
  {
    path: "/master/group-classes/list",
    name: "apps-masters-group-class-list",
    component: () => import("@/views/apps/GroupClass/MasterGroupClassList.vue"),
    meta: {
      resource: "GroupClass",
      action: "GetMasterGroupClassesByMasterId",
    },
  },
  {
    path: "/master/group-classes/:id",
    name: "apps-masters-group-class-details",
    component: () =>
      import("@/views/apps/GroupClass/MasterGroupClassDetails.vue"),
    meta: {
      resource: "GroupClass",
      action: "GetGroupClassMasterStatusByGroupClassMasterId",
    },
  },

  {
    path: "/termic-courses/list",
    name: "termic-courses-list",
    component: () => import("@/views/apps/TermicCourses/TermicCourseList.vue"),
    meta: {
      resource: "TermicCourses",
      action: "GetAll",
    },
  },

  {
    path: "/termic-courses/create",
    name: "termic-courses-create",
    component: () =>
      import("@/views/apps/TermicCourses/CreateTermicCourse.vue"),
    meta: {
      resource: "TermicCourses",
      action: "Create",
    },
  },

  {
    path: "/termic-courses/:id",
    name: "termic-courses-details",
    component: () =>
      import("@/views/apps/TermicCourses/SingleCourseDetail.vue"),
    meta: {
      resource: "TermicCourses",
      action: "GetById",
    },
  },

  {
    path: "/support/list",
    name: "support-list",
    component: () => import("@/views/apps/Support/SupportList.vue"),
    meta: {
      resource: "Counseling",
      action: "CounselingList",
    },
  },
  {
    path: "/support/packages",
    name: "support-packages",
    component: () => import("@/views/apps/Support/SupportPackages.vue"),
    meta: {
      resource: "Counseling",
      action: "CounselingList",
    },
  },
  {
    path: "/support/packagesReport",
    name: "support-packagesReport",
    component: () => import("@/views/apps/Support/packagesReport.vue"),
    meta: {
      resource: "Counseling",
      action: "CounselingList",
    },
  },
  {
    path: "/support/list/:id",
    name: "support-details",
    component: () => import("@/views/apps/Support/SupportDetails.vue"),
    meta: {
      resource: "Counseling",
      action: "CounselingList",
    },
  },

  // {
  //   path: '/apps/chats/:id',
  //   name: 'apps-chats-id',
  //   resource: 'Support',
  //   action: 'Support',
  //   component: () => import('@/views/apps/chat/Chat.vue'),
  //   meta: {
  //     // contentRenderer: 'sidebar-left',
  //     contentClass: 'chat-application',
  //   },
  // },
];
